<template>
  <div>
    <!-- V2 offers only when enabled -->
    <modal-offer-dynamic
      v-if="useV2Offers && currentOffer"
      :offer-data="currentOffer"
      @hidden="onOfferHidden"
    />

    <!-- Legacy offers when v2 disabled -->
    <template v-else>
      <modal-offer-lobby-3 v-if="offerId === 'modal-offer-lobby-3'" />
      <modal-offer-lobby-2 v-if="offerId === 'modal-offer-lobby-2'" />
      <modal-offer-lobby-1 v-if="offerId === 'modal-offer-lobby-1'" />
      <modal-offer-daily-3 v-if="offerId === 'modal-offer-daily-3'" />
      <modal-offer-daily-2 v-if="offerId === 'modal-offer-daily-2'" />
      <modal-offer-daily-1 v-if="offerId === 'modal-offer-daily-1'" />

      <modal-offer-starter-1 v-if="offerId === 'modal-offer-starter-1'" />
      <modal-offer-halloween-1 v-if="offerId === 'modal-offer-halloween-1'" />
      <modal-offer-winter-1 v-if="offerId === 'modal-offer-winter-1'" />
      <modal-offer-winterhere-1 v-if="offerId === 'modal-offer-winterhere-1'" />
      <modal-offer-spring-1 v-if="offerId === 'modal-offer-spring-1'" />
      <modal-offer-summer1 v-if="offerId === 'modal-offer-summer-1'" />
      <modal-offer-ab-testing v-if="offerId === 'modal-offer-ab-testing'" />
      <modal-offer-autumn-1 v-if="offerId === 'modal-offer-autumn-1'" />
      <modal-offer-xmas-1 v-if="offerId === 'modal-offer-xmas-1'" />
      <modal-offer-xmasrush-3 v-if="offerId === 'modal-offer-xmasrush-3'" />
    </template>
  </div>
</template>

<script>
import offerModal from "@/mixins/offerModal";
import { fetchOfferByTrigger, OFFER_TRIGGERS } from "@/API/offers";
import ModalOfferDynamic from "@/components/shop/offers/modal-offer-dynamic.vue";
import ModalOfferHalloween1 from "@/components/shop/offers/modal-offer-halloween-1.vue";
import ModalOfferWinter1 from "@/components/shop/offers/modal-offer-winter-1.vue";
import ModalOfferWinterhere1 from "@/components/shop/offers/modal-offer-winterhere-1.vue";
import ModalOfferSpring1 from "@/components/shop/offers/modal-offer-spring-1.vue";
import ModalOfferLobby3 from "@/components/shop/offers/modal-offer-lobby-3.vue";
import ModalOfferLobby2 from "@/components/shop/offers/modal-offer-lobby-2.vue";
import ModalOfferLobby1 from "@/components/shop/offers/modal-offer-lobby-1.vue";
import ModalOfferDaily3 from "@/components/shop/offers/modal-offer-daily-3.vue";
import ModalOfferDaily2 from "@/components/shop/offers/modal-offer-daily-2.vue";
import ModalOfferDaily1 from "@/components/shop/offers/modal-offer-daily-1.vue";

import ModalOfferStarter1 from "@/components/shop/offers/modal-offer-starter-1.vue";
import ModalOfferAbTesting from "@/components/shop/offers/modal-offer-ab-testing";
import ModalOfferSummer1 from "@/components/shop/offers/modal-offer-summer-1";
import ModalOfferAutumn1 from "@/components/shop/offers/modal-offer-autumn-1.vue";
import ModalOfferXmas1 from "@/components/shop/offers/modal-offer-xmas-1.vue";
import ModalOfferXmasrush3 from "@/components/shop/offers/modal-offer-xmasrush-3.vue";

export default {
  name: "PipeLobbyOffer",
  components: {
    ModalOfferDynamic,
    ModalOfferSummer1,
    ModalOfferAbTesting,
    ModalOfferHalloween1,
    ModalOfferWinter1,
    ModalOfferWinterhere1,
    ModalOfferSpring1,
    ModalOfferLobby3,
    ModalOfferLobby2,
    ModalOfferLobby1,
    ModalOfferDaily3,
    ModalOfferDaily2,
    ModalOfferDaily1,
    ModalOfferStarter1,
    ModalOfferAutumn1,
    ModalOfferXmas1,
    ModalOfferXmasrush3,
  },
  mixins: [offerModal],
  data() {
    return {
      currentOffer: null,
    };
  },
  computed: {
    offerId() {
      return this.$store.state.shop.offerId;
    },
    useV2Offers() {
      return !!this.$whitelabel?.featuresEnabled?.v2Offers;
    },
  },
  mounted() {
    console.log("--------- Pipeline Step LobbyOffer ----------");

    if (!this.popupsUnlocked) {
      // console.log("Popups not unlocked - skipping offers");
      this.$store.commit("popups/setNextPipelineQueueStep");
      return;
    }

    if (this.useV2Offers) {
      this.$store.commit("shop/setOfferId", "");
      this.fetchLobbyOffers();
    } else {
      if (!this.offerId) {
        this.currentOffer = null;
        this.$store.commit("popups/setNextPipelineQueueStep");
      }
    }
  },
  methods: {
    async fetchLobbyOffers() {
      try {
        // console.log("Fetching lobby offer via v2 API...");
        const data = await fetchOfferByTrigger(OFFER_TRIGGERS.LOBBY);

        if (data && data.offer) {
          // console.log("Received offer:", data.offer);
          // Display the offer in the dynamic modal
          this.$store.commit("shop/setGlobalOfferData", data.offer);
          this.currentOffer = data.offer;
        } else {
          this.$store.commit("shop/clearGlobalOfferData");
          // console.log("No offer available");
          this.$store.commit("popups/setNextPipelineQueueStep");
        }
      } catch (error) {
        console.error("Error fetching lobby offer:", error);
        // Continue to next pipeline step even on error
        this.$store.commit("popups/setNextPipelineQueueStep");
      }
    },
    onOfferHidden() {
      // When user closes the offer modal, proceed to next pipeline step
      this.currentOffer = null;
      this.$store.commit("popups/setNextPipelineQueueStep");
    },
  },
};
</script>

<style scoped lang="scss"></style>
